import React from "react";
import { Icon } from "../../Component";

const ComparisonBadge = ({ current, previous, period = "vs période précédente", showPercentage = true }) => {
  if (previous === null || previous === undefined || previous === 0) {
    return null;
  }

  const change = ((current - previous) / previous) * 100;
  const roundedChange = Math.round(change * 10) / 10;
  const isPositive = roundedChange >= 0;
  const colorClass = isPositive ? "text-success" : "text-danger";
  const iconName = isPositive ? "arrow-up" : "arrow-down";

  return (
    <div className={`comparison-badge ${colorClass} d-flex align-items-center`}>
      <Icon name={iconName} className="me-1"></Icon>
      <span>
        {showPercentage && `${isPositive ? "+" : ""}${roundedChange}%`}
        {period && <span className="text-muted ms-1 small">({period})</span>}
      </span>
    </div>
  );
};

export default ComparisonBadge;






